import React from 'react';
import { bool, string } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import BookmarkIcon from '../../../../assets/images/icons/search/empty-bookmark.svg';
import ListIcon from '../../../../assets/images/icons/search/empty-list.svg';

export default function ListImage({ isFavoriteRow, isEmptyListRow, listTitle, imgUrl }) {
  if (isFavoriteRow) {
    return <img src={BookmarkIcon} alt={StringConstantsMixin.strings.LIST_MODAL.MY_FAVORITES} />;
  }

  if (isEmptyListRow) {
    return <img className={styles.listImage} src={ListIcon} alt={StringConstantsMixin.strings.LIST_MODAL.NAME_YOUR_LIST} />;
  }

  return <img className={styles.listImage} src={imgUrl} alt={listTitle} />;
}

ListImage.propTypes = {
  isFavoriteRow: bool,
  isEmptyListRow: bool,
  listTitle: string,
  imgUrl: string
};

ListImage.defaultProps = {
  isFavoriteRow: false,
  isEmptyListRow: false,
  listTitle: '',
  imgUrl: ''
};
